import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyANW9fTPYF2GJKLpihf141-qWl_nvU8pSM",
    authDomain: "pookie-c6892.firebaseapp.com",
    projectId: "pookie-c6892",
    storageBucket: "pookie-c6892.appspot.com",
    messagingSenderId: "400425806459",
    appId: "1:400425806459:web:eb01c566ac5e15293a50de",
    measurementId: "G-W5BZYM9YJK",
  };

// Initialize Firebase only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Export services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
